import { Theme, alpha } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

/** The round icon buttons on the top bar (theme, notifications). */
export const barIconButtonSx = (theme: Theme): SystemStyleObject<Theme> => ({
  width: 36,
  height: 36,
  color: 'text.secondary',
  transition: theme.transitions.create(['background-color', 'color'], { duration: 150 }),
  '&:hover': { bgcolor: alpha(theme.palette.text.primary, 0.06), color: 'text.primary' },
  '& svg': { fontSize: 20 },
});
